"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContractErrors;
(function (ContractErrors) {
    ContractErrors[ContractErrors["Unknown"] = -1] = "Unknown";
    ContractErrors[ContractErrors["NotOven"] = 1] = "NotOven";
    ContractErrors[ContractErrors["NotOvenProxy"] = 2] = "NotOvenProxy";
    ContractErrors[ContractErrors["NotOracle"] = 3] = "NotOracle";
    ContractErrors[ContractErrors["NotGovernor"] = 4] = "NotGovernor";
    ContractErrors[ContractErrors["NotMinter"] = 5] = "NotMinter";
    ContractErrors[ContractErrors["NotOwner"] = 6] = "NotOwner";
    ContractErrors[ContractErrors["NotOvenFactory"] = 7] = "NotOvenFactory";
    ContractErrors[ContractErrors["NotAdmin"] = 8] = "NotAdmin";
    ContractErrors[ContractErrors["NotPauseGuardian"] = 9] = "NotPauseGuardian";
    ContractErrors[ContractErrors["NotUnderCollateralized"] = 10] = "NotUnderCollateralized";
    ContractErrors[ContractErrors["OvenUnderCollateralized"] = 11] = "OvenUnderCollateralized";
    ContractErrors[ContractErrors["BadState"] = 12] = "BadState";
    ContractErrors[ContractErrors["BadDestination"] = 13] = "BadDestination";
    ContractErrors[ContractErrors["WrongAsset"] = 14] = "WrongAsset";
    ContractErrors[ContractErrors["AmountNotAllowed"] = 15] = "AmountNotAllowed";
    ContractErrors[ContractErrors["Liquidated"] = 16] = "Liquidated";
    ContractErrors[ContractErrors["StaleData"] = 17] = "StaleData";
    ContractErrors[ContractErrors["Paused"] = 18] = "Paused";
    ContractErrors[ContractErrors["CannotReceiveFunds"] = 19] = "CannotReceiveFunds";
    ContractErrors[ContractErrors["DebtCeiling"] = 20] = "DebtCeiling";
    ContractErrors[ContractErrors["OvenMaximumExceeded"] = 21] = "OvenMaximumExceeded";
    ContractErrors[ContractErrors["TokenNoTransferPermission"] = 22] = "TokenNoTransferPermission";
    ContractErrors[ContractErrors["TokenInsufficientBalance"] = 23] = "TokenInsufficientBalance";
    ContractErrors[ContractErrors["TokenUnsafeAllowanceChange"] = 23] = "TokenUnsafeAllowanceChange";
    ContractErrors[ContractErrors["TokenNotAdministrator"] = 24] = "TokenNotAdministrator";
    ContractErrors[ContractErrors["BadSplits"] = 25] = "BadSplits";
    ContractErrors[ContractErrors["NotAllowedToLiquidate"] = 26] = "NotAllowedToLiquidate";
    ContractErrors[ContractErrors["NotSavingsAccount"] = 27] = "NotSavingsAccount";
    ContractErrors[ContractErrors["BadSender"] = 28] = "BadSender";
})(ContractErrors || (ContractErrors = {}));
exports.default = ContractErrors;
//# sourceMappingURL=contract-errors.js.map